import React, { Component } from 'react'
import Slider from 'react-slick'

import TaskImage from './taskImage'
import { Task } from './types'
import { Image } from '../../core/types'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  task: Task
  toggleLayout: Callback
}

export default class TaskImageComponent extends Component<Props> {
  static displayName = 'TaskImageComponent'

  renderImage = () => {
    const { task, toggleLayout } = this.props

    const ConditionalWrapper = ({ condition, wrapper, children }) =>
      condition ? wrapper(children) : children

    return (
      <ConditionalWrapper
        condition={task.verifiables.length > 1}
        wrapper={(children) => (
          <div className="container">
            <Slider adaptiveHeight={true} infinite={false}>
              {children}
            </Slider>
          </div>
        )}
      >
        {task.verifiables.map((verifiable, index) => {
          const image = verifiable as Image
          const contentType = image.contentType || 'UNKNOWN'

          return (
            <div key={index}>
              {contentType.match(/pdf/) ? (
                <a href={image.url} target="_blank">
                  View PDF
                </a>
              ) : (
                <TaskImage imgUrl={image.url} toggleLayout={toggleLayout} />
              )}
            </div>
          )
        })}
      </ConditionalWrapper>
    )
  }

  render() {
    return <div className="task-image-component">{this.renderImage()}</div>
  }
}
